import { HostListener, Component, OnInit, ElementRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { empty } from 'rxjs';
import { ApiMethod } from '../../apimethods/api-method';
import { GlobalConstants } from '../../common/global-constants';
import { DefectManagementModel } from '../../defect-management/defect-management-model';


declare var $;

@Component({
  selector: 'app-defect-response',
  templateUrl: './defect-response.component.html',
  styleUrls: ['./defect-response.component.css']
})
/** defect-response component*/
export class DefectResponseComponent implements OnInit {
  journalList: any; issueList: any; articleList: any;
  DefectAreaList: any; DefectCategoryList: any; DefectInstructionList: any;
  DefectStatusListAPI: any;
  CategoryIdPop: any; Acronym: string; ArticleNo: string; VolIssue: string; AreaName: string;
  Category: string; Instructions: string; ResponseMode: string;
  Volume: any;
  Description: any;
  showModalDescription: boolean;
  DownloadFilepath: any;
  popUpButtonText: string;
  popUpButtonRejectDefect: string;
  popUpButtonImplemented: string;
  Response: string;
  file: any = null;
  fileBase64: any = null;
  FileName: any = null;
  statusRoot: string = '';
  fileCrt: any = null;
  fileBase64Crt: any = null;
  fileNameCrt: any = null;
  statusCrt: string = '';
  uploadFilePath: any;
  RequestFeedback: any;
  reportTypeList: any;
  DefectDueDate: any;
  disableValidation: boolean = false;
  minDate: string;
  maxDate: string;
  DefectStatus: string;
  selectedValue: string = '';
  GetDefectCategoryList: any;
  rootFilePath: any;
  correctiveFilePath: any;
  title: string;
  dtOptions: any;
  tableData = [];
  ajournalAccess: any;
  showButton: any;
  // used to capture the event and sent to parent to load page on saved a new record
  @Output() recordUpdated = new EventEmitter<void>();
  @ViewChild('textArea') textArea: any;
  chkRootCauseData: string;
  chkPreventiveActionData: string;
  chkCorrectiveActionData: string;
  chkApprove: any;
  chkReject: any;
  chkAttachements: any;
  chkUserLevel: any;
  //modelItem: any;
  /** defect-response ctor */
  constructor(private router: Router, http: HttpClient) {

  }

  ngOnInit(): void {

    $("#DefectStatus").select2({
      placeholder: "Select Status", dropdownParent: "#divResponseData"
    });
    $("#DefectStatus").val([]).trigger("change");

  }
  OnClick(): void {
    this.update();

  }
  openOffCanvasForDescription() {
    this.showModalDescription = true;
  }
  hideDescription() {
    this.showModalDescription = false;
  }

  update(): void {
    //for RPC user any record in Tbl_RoleMenuAction for menuID = 57 for the respective roleId  
    if (this.ResponseMode == 'Response') {
      this.UpdateDefectMgtResponse();
    }
    //for super user view under userroles if defectMgttresponse view/add/update null fields then super user
    if (this.ResponseMode == 'Add') {
      this.UpdateDefectResponse();
    }

  }
  // to show and update the response details for RPC user
  ShowInfoPopUp(): void {

    $("#LoadingImage").show();
    $('#divResponseData').hide();
    $('#DivAddData').show();
    this.ClearData();
    $("#textbuttonh").show();
    $("#textresponseif").hide();



    if (localStorage.aEID != 0) {
      var dataParam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
      };
      ApiMethod.postMethod('api/populatedefectmgt', dataParam).subscribe(
        result => {
          let _dataItem = result.DataItem;
          let _defectdata = result.defectData;

          //Role Based UI Changes
          var menuList = JSON.parse(localStorage.aMenuList);
          const DefectManagement = menuList.find(
            (menuItem) => menuItem.MenuID == 17);
          var DefectResponse = menuList.find(
            (menuItem) => menuItem.MenuID == 57);

          var RootCauseAnalysis = menuList.find(
            (menuItem) => menuItem.MenuID == 77);

          var PreventiveAction = menuList.find(
            (menuItem) => menuItem.MenuID == 78);

          var CorrectiveAction = menuList.find(
            (menuItem) => menuItem.MenuID == 79);

          var Implementation = menuList.find(
            (menuItem) => menuItem.MenuID == 123);

          var Approver = menuList.find((menuItem) => menuItem.MenuID == 87);
          var Reject = menuList.find((menuItem) => menuItem.MenuID == 88);

          if (Reject && Reject.Action.toLowerCase().includes('update') == true) {

            $("#Txt_rootCause").prop('disabled', true);
            $('#doc_DefectCorrectedFile').prop('disabled', true);
            $('#doc_DefectCorrectedFile_crtAct').prop('disabled', true);
            $("#Txt_CorrectiveAction").prop('disabled', true);
            $("#Txt_PreventiveAction").prop('disabled', true);
          }

          $("#Txt_rootCause").prop('disabled', true);
          $("#Txt_CorrectiveAction").prop('disabled', true);
          $("#Txt_PreventiveAction").prop('disabled', true);
          $('#doc_DefectCorrectedFile').prop('disabled', true);
          $('#doc_DefectCorrectedFile_crtAct').prop('disabled', true);

          if (RootCauseAnalysis.Action.toLowerCase().includes('update')) {
            $("#Txt_rootCause").prop('disabled', false);
            $("#doc_DefectCorrectedFile").prop('disabled', false);

          }
          if (CorrectiveAction.Action.toLowerCase().includes('update')) {
            $("#Txt_CorrectiveAction").prop('disabled', false);
            $("#doc_DefectCorrectedFile_crtAct").prop('disabled', false);

          }
          if (PreventiveAction.Action.toLowerCase().includes('update')) {
            $("#Txt_PreventiveAction").prop('disabled', false);
          }

          //Show Data for add and edit defect

          if (_dataItem.length != 0) {

            $('#defcorrectuploadbtn').show();
            $('#Status').hide();
            $('#DefectComments').hide();

            //get the value for validations on update

            this.chkRootCauseData = _dataItem[0].RootCasue;
            this.chkPreventiveActionData = _dataItem[0].PreventiveAction;
            this.chkCorrectiveActionData = _dataItem[0].CorrectiveAction;
            this.chkAttachements = _dataItem[0].Attachments;
            this.rootFilePath = _dataItem[0].RootCause_FilePath;
            this.correctiveFilePath = _dataItem[0].Corrective_FilePath;
            this.uploadFilePath = _dataItem[0].Attachments;


            this.Acronym = _defectdata[0].Acronym;
            this.ArticleNo = _defectdata[0].ArticleNo;
            this.VolIssue = _defectdata[0].Volume;
            this.AreaName = _defectdata[0].AreaName;
            this.Category = _defectdata[0].Category;
            this.Instructions = _defectdata[0].Instructions;
            this.Description = _defectdata[0].Description;
            this.DefectDueDate = _defectdata[0].DefectDueDate;

            //Root Cause Data 
            $("#txtDefectResponse").val(_dataItem[0].ProductionResponse);
            $("#Txt_RootCauseuser").val(localStorage.aLoginName);
            $("#Txt_ResponsibleUser").val(_dataItem[0].ResponsiblePerson);
            $("#ddlComplaintType").val(_dataItem[0].ComplaintType).change();
            $("#ddlCriticalLevel").val(_dataItem[0].CriticalLevel).change();
            $("#Txt_Implement").val(_dataItem[0].ImplementDate);
            $("#Txt_Problem").val(_dataItem[0].ProblemDate);
            $("#Txt_rootCause").val(_dataItem[0].RootCasue);
            $("#Txt_CorrectiveAction").val(_dataItem[0].CorrectiveAction);
            $("#Txt_PreventiveAction").val(_dataItem[0].PreventiveAction);
            $("#DefectStatus").val(_dataItem[0].DefectStatus).change();
           

            $('#divResponseData').show(); // div for add /edit

            this.Response = "Defect Response Details";

            //check for attachment upload path to disable
            if (this.chkAttachements == "" || this.chkAttachements == null) {
              $("#Download").attr('disabled', true);
            } else { $("#Download").attr('disabled', false); }


            if ((Reject && Reject.Action.toLowerCase().includes('update') == true) || (Approver && Approver.Action.toLowerCase().includes('update') == true)) {

              $('#Status').show();
              $('#DefectComments').show();
              $("#UpdateAdd").show();
            }
            //approve reject page should not be editable for RPC user
            if (_dataItem[0].DefectStatus == 'Approve' || _dataItem[0].DefectStatus == 'Reject') {

              this.Disablepopupfields();

              $("#txtDefectResponse").prop('disabled', 'disabled');
              $("#doc_DefectCorrectedFile").prop('disabled', 'disabled');
              $('#doc_DefectCorrectedFile_crtAct').prop('disabled', 'disabled');
              // show status and comments in disabled mode
              $('#Status').show();
              $('#DefectComments').show();
              $("#txtDefectResponse").prop('disabled', 'disabled');
              $("#DefectStatus").prop('disabled', 'disabled');

              $('#UpdateIcon').hide();
              
              $('#Implemented').show();
              $('#RejectDefect').show();

              if (_dataItem[0].DefectStatus == 'Reject') {
                $("#Implemented").hide();
                $("#RejectDefect").hide();
              }
              $("#mainRootUpload").hide();
              $("#mainCorrectiveUpload").hide();

            } else {
              $("#DefectStatus").prop('disabled', false);
              $("#txtDefectResponse").prop('disabled', false);

              $("#ddlComplaintType").prop('disabled', false);
              $("#ddlCriticalLevel").prop('disabled', false);
              $("#Txt_ResponsibleUser").prop('disabled', false);
              $("#mainRootUpload").show();
              $("#mainCorrectiveUpload").show();

              $('#UpdateIcon').show();
              $('#Implemented').hide();
              $('#RejectDefect').hide();
            }



            // file path check - if record exist then show download option for corrective cause

            // if txt box is disabled then diable the upload function
            if ($("#Txt_rootCause").prop('disabled')) {
              $("#doc_DefectCorrectedFile").prop('disabled', true);
            } else {
              $("#doc_DefectCorrectedFile").prop('disabled', false);
            }
            if ($("#Txt_CorrectiveAction").prop('disabled')) {
              $("#doc_DefectCorrectedFile_crtAct").prop('disabled', true);
            } else {
              $("#doc_DefectCorrectedFile_crtAct").prop('disabled', false);
            }

            // file path check - if record exist then show download option for root cause

            if (this.rootFilePath == "" || this.rootFilePath == null) {
              $('#doc_DefectCorrectedFile').val(""); 
              $('#defcorrectuploadbtn').show();
              $('#DownloadCorrectFile').hide();
            } else {
              $('#DownloadCorrectFile').show(); // show the download button
              $('#defcorrectuploadbtn').hide(); // hide the upload option

            }

            if (this.correctiveFilePath == "" || this.correctiveFilePath == null) {

              $('#doc_DefectCorrectedFile_crtAct').val("");
              $('#defcorrectuploadbtnCorrectiveAct').show();
              $('#DownloadCorrectFileCrtAct').hide();

            } else {
              $('#defcorrectuploadbtnCorrectiveAct').hide();
              $('#DownloadCorrectFileCrtAct').show();
            }
          }
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
      $("#LoadingImage").hide();
      this.title = "Update Defect Details"; //Dynamic Data
      this.popUpButtonText = "Update";
      this.popUpButtonImplemented = "Implemented";
      this.popUpButtonRejectDefect = "Reject Defect";
    }
    else {
      this.title = "Add Defect Details"; // Dynamic Data
      this.popUpButtonText = "Save";
      $("#LoadingImage").hide();
    }

  }
  //super user response
  ShowDataResponse(): void {

    this.ClearData();
    $('#divResponseData').hide();
    $('#DivAddData').show();
    //this.ClearData();
    $("#textbuttonh").show();
    $("#textresponseif").hide();
    if (localStorage.aEID != 0) {
      var dataParam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
      };
      ApiMethod.postMethod('api/populatedefectmgt', dataParam).subscribe(
        result => {
          let _dataItem = result.DataItem;
          let _defectdata = result.defectData;
          //Role Based UI Changes
          var menuList = JSON.parse(localStorage.aMenuList);
          var Approver = menuList.find((menuItem) => menuItem.MenuID === 87);
          var Reject = menuList.find((menuItem) => menuItem.MenuID === 88);

          // if super admin with approve /reject permission defectsataus field and comment section enabled
          if (Approver && Reject && (Approver.Action.toLowerCase().includes('update') || Reject.Action.toLowerCase().includes('update'))) {

            $("#txtDefectResponse").prop('disabled', false);
            $("#DefectStatus").prop('disabled', false);
            $('#Status').show();
            $('#DefectComments').show();

            $("#ddlComplaintType").prop('disabled', true);
            $("#ddlCriticalLevel").prop('disabled', true);
            $("#Txt_ResponsibleUser").prop('disabled', true);

          } else {
            $("#DefectStatus").prop('disabled', true);
            $("#txtDefectResponse").prop('disabled', true);

            $("#ddlComplaintType").prop('disabled', false);
            $("#ddlCriticalLevel").prop('disabled', false);
            $("#Txt_ResponsibleUser").prop('disabled', false);


          }

          //Show  defect Data 
          if (_dataItem.length != 0) {

            this.chkAttachements = _dataItem[0].Attachments;
            this.rootFilePath = _dataItem[0].RootCause_FilePath;
            this.correctiveFilePath = _dataItem[0].Corrective_FilePath;

            this.uploadFilePath = _dataItem[0].Attachments;
            $("#ddlJournals").val(_dataItem[0].JournalId).change();
            $("#ddlArticle").val(_dataItem[0].ArticleId).change();
            $("#ddlIssue").val(_dataItem[0].IssueId).change();
            $("#ddlDefectArea").val(_dataItem[0].DefectAreaId).change();
            $("#ddlDefectCategory").val(_dataItem[0].DefectCategoryId).change();


            //Populate Category from Area and Selected Id
            $("#ddlComplaintType").val(_dataItem[0].ComplaintType).change();
            $("#ddlCriticalLevel").val(_dataItem[0].CriticalLevel).change();
            $("#Txt_ResponsibleUser").val(_dataItem[0].ResponsiblePerson);

            $("#ddlDefectInstruction").val(_dataItem[0].DefectInstructionId).change();
            $("#ddlFeedbackRequest").val(_dataItem[0].RequestFeedback).change();
            $("#txtDescription").val(_dataItem[0].Description);

            if (_dataItem[0].DefectDueDate != null) {
              $("#Txt_DefectDueDate").val(GlobalConstants.SetValue_FormatDate(_dataItem[0].DefectDueDate));
            }
            // loading data for Reponse Data for super user
            if (this.ResponseMode == 'Add') {

              this.Disablepopupfields();

              this.Acronym = _defectdata[0].Acronym;
              this.ArticleNo = _defectdata[0].ArticleNo;
              this.VolIssue = _defectdata[0].Volume;
              this.AreaName = _defectdata[0].AreaName;
              this.Category = _defectdata[0].Category;
              this.Instructions = _defectdata[0].Instructions;
              this.Description = _defectdata[0].Description;
              this.DefectDueDate = _defectdata[0].DefectDueDate;
              this.uploadFilePath = _dataItem[0].Attachments;

              this.rootFilePath = _dataItem[0].RootCause_FilePath;
              this.correctiveFilePath = _dataItem[0].Corrective_FilePath;

              //Root Cause Data 
              $("#txtDefectResponse").val(_dataItem[0].ProductionResponse);
              $("#Txt_RootCauseuser").val(localStorage.aLoginName);

              $("#Txt_ResponsibleUser").val(_dataItem[0].ResponsiblePerson);
              $("#ddlComplaintType").val(_dataItem[0].ComplaintType).change();
              $("#ddlCriticalLevel").val(_dataItem[0].CriticalLevel).change();

              $("#Txt_rootCause").val(_dataItem[0].RootCasue);
              $("#Txt_CorrectiveAction").val(_dataItem[0].CorrectiveAction);
              $("#Txt_PreventiveAction").val(_dataItem[0].PreventiveAction);
              $("#DefectStatus").val(_dataItem[0].DefectStatus).change();

              //  $('#defcorrectuploadbtn').hide(); chk

              $('#divResponseData').show();
              $('#DivAddData').hide();


              this.Response = "Defect Response Details";
              this.popUpButtonText = "Update";

            }

            if (this.ResponseMode == 'Response') {

              this.Disablepopupfields();

              this.Acronym = _defectdata[0].Acronym;
              this.ArticleNo = _defectdata[0].ArticleNo;
              this.VolIssue = _defectdata[0].Volume;
              this.AreaName = _defectdata[0].AreaName;
              this.Category = _defectdata[0].Category;
              this.Instructions = _defectdata[0].Instructions;
              this.Description = _defectdata[0].Description;
              this.DefectDueDate = _defectdata[0].DefectDueDate;
              this.uploadFilePath = _dataItem[0].Attachments;

              this.rootFilePath = _dataItem[0].RootCause_FilePath;
              this.correctiveFilePath = _dataItem[0].Corrective_FilePath;

              //Root Cause Data 
              $("#txtDefectResponse").val(_dataItem[0].ProductionResponse);
              $("#Txt_RootCauseuser").val(localStorage.aLoginName);
              $("#Txt_ResponsibleUser").val(_dataItem[0].ResponsiblePerson);
              $("#ddlComplaintType").val(_dataItem[0].ComplaintType).change();
              $("#ddlCriticalLevel").val(_dataItem[0].CriticalLevel).change();
              $("#Txt_rootCause").val(_dataItem[0].RootCasue);
              $("#Txt_CorrectiveAction").val(_dataItem[0].CorrectiveAction);
              $("#Txt_PreventiveAction").val(_dataItem[0].PreventiveAction);
              $("#DefectStatus").val(_dataItem[0].DefectStatus).change();

              // $('#defcorrectuploadbtn').hide();chk
              $('#divResponseData').show();
              $('#DivAddData').hide();
              this.Response = "Defect Response Details";
              this.popUpButtonText = "Update";
            }

            if (_dataItem[0].DefectStatus == 'Approve' || _dataItem[0].DefectStatus == 'Reject') {

              this.Disablepopupfields();
              $("#DefectStatus").attr('disabled', 'disabled');
              $("#txtDefectResponse").attr('disabled', 'disabled');
              $('#UpdateIcon').hide();
              $('#Implemented').show();
              $('#RejectDefect').show();
              $("#ddlComplaintType").prop('disabled', true);
              $("#ddlCriticalLevel").prop('disabled', true);
              $("#Txt_ResponsibleUser").prop('disabled', true);

              $("#mainRootUpload").hide();
              $("#mainCorrectiveUpload").hide();

            }
            else {
              $("#DefectStatus").attr('disabled', false);
              $("#txtDefectResponse").attr('disabled', false);
              $('#UpdateIcon').show();
              $('#Implemented').hide();
              $('#RejectDefect').hide();
              $("#mainRootUpload").show();
              $("#mainCorrectiveUpload").show();

            }
            if (this.chkAttachements == "" || this.chkAttachements == null) {
              $("#Download").attr('disabled', true);
            } else { $("#Download").attr('disabled', false); }

            // file path check - if record exist then show download option for root cause
            if (this.rootFilePath == "" || this.rootFilePath == null) {
              //alert(this.rootFilePath == "");
              //alert(this.rootFilePath == null);

              $('#doc_DefectCorrectedFile').val("");
              $('#defcorrectuploadbtn').show();
              $('#DownloadCorrectFile').hide();


            } else {
              $('#DownloadCorrectFile').show(); // show the download button
              $('#defcorrectuploadbtn').hide();// hide the upload option

            }

            if (this.correctiveFilePath == "" || this.correctiveFilePath == null) {

              $('#doc_DefectCorrectedFile_crtAct').val("");
              $('#defcorrectuploadbtnCorrectiveAct').show();

              $('#DownloadCorrectFileCrtAct').hide();

            } else {

              $('#defcorrectuploadbtnCorrectiveAct').hide();
              $('#DownloadCorrectFileCrtAct').show();
            }
            // if txt box is disabled then diable the upload function
            if ($("#Txt_rootCause").prop('disabled')) {
              $("#doc_DefectCorrectedFile").prop('disabled', true);
            } else {
              $("#doc_DefectCorrectedFile").prop('disabled', false);
            }
            if ($("#Txt_CorrectiveAction").prop('disabled')) {
              $("#doc_DefectCorrectedFile_crtAct").prop('disabled', true);
            } else {
              $("#doc_DefectCorrectedFile_crtAct").prop('disabled', false);
            }

          }
        }, error => {

          ngswal("Failed !", error.message, "warning");
        });

      this.title = "Update Defect Details"; //Dynamic Data
      this.popUpButtonText = "Update";
    } else {
      this.title = "Add Defect Details"; // Dynamic Data
      this.popUpButtonText = "Save";

    }
  }
  Disablepopupfields() {
    $('#Txt_RootCauseuser').attr('disabled', 'disabled');
    $('#Txt_ResponsibleUser').attr('disabled', 'disabled');
    $('#ddlComplaintType').attr('disabled', 'disabled');
    $('#ddlCriticalLevel').attr('disabled', 'disabled');
    $('#Txt_rootCause').attr('disabled', 'disabled');
    $('#Txt_CorrectiveAction').attr('disabled', 'disabled');
    $('#Txt_RootCauseuser').attr('disabled', 'disabled');
    $('#Txt_PreventiveAction').attr('disabled', 'disabled');

  }
  ClearData(): void {
    $("#ddlJournals").val(0).change();
    $("#ddlIssue").val(0).change();
    $("#ddlArticle").val(0).change();
    $("#ddlDefectArea").val(0).change();
    $("#ddlDefectCategory").val(0).change();
    $("#ddlDefectInstruction").val(0).change();
    $("#txtDescription").val('');
    $("#Txt_DefectDueDate").val('');
    $("#ddlCurrentStatus").val(0).change();
    $("#ddlFeedbackRequest").val(0).change();
    $("#txtDefectResponse").val('').change();
    $("#Txt_RootCauseuser").val('').change();
    $("#Txt_ResponsibleUser").val('').change();
    $("#ddlComplaintType").val(0).change();
    $("#ddlCriticalLevel").val(0).change();
    $("#Txt_rootCause").val('').change();
    $("#Txt_CorrectiveAction").val('');
    $("#Txt_PreventiveAction").val('');
    $("#textresponseif").val('').change();
    $('#Responsetab').val('').change();
    $('#DefectStatus').val(0).change();
    $("#Txt_DefectDueDate").val(0).change();
    $("#doc_DefectCorrectedFile").val("");
    $("#doc_DefectCorrectedFile_crtAct").val("");

    this.file = null;
    this.fileCrt = null;
  }
 

  DefectDataDownloadFiles() {
    $("#LoadingImage").show();
    var aEid = localStorage.aEID;
    ApiMethod.Downloadfile("api/DownloadDefectFile" + "/" + aEid);
    this.ShowInfoPopUp();
    this.hide();
    $("#LoadingImage").hide();
  }

  //update for PCR user
  UpdateDefectMgtResponse(): void {
    let fileName = null;
    let fileSize = null;

    let fileNameCrt = null;
    let fileSizeCrt = null;


    var menuList = JSON.parse(localStorage.aMenuList);
    const DefectManagement = menuList.find(
      (menuItem) => menuItem.MenuID == 17);
    var DefectResponse = menuList.find(
      (menuItem) => menuItem.MenuID == 57);

    var RootCauseAnalysis = menuList.find(
      (menuItem) => menuItem.MenuID == 77);

    var PreventiveAction = menuList.find(
      (menuItem) => menuItem.MenuID == 78);

    var CorrectiveAction = menuList.find(
      (menuItem) => menuItem.MenuID == 79);

    var Approver = menuList.find((menuItem) => menuItem.MenuID == 87);
    var Reject = menuList.find((menuItem) => menuItem.MenuID == 88);

    //reject bypass these conditions
    console.log($("#ddlComplaintType").val());
    if ($("#ddlComplaintType").val() == null || $("#ddlComplaintType").val() == "" ) {
      ngswal("Warning !", "Please Select Complaint Type !", "warning");

    } else if ($('#ddlCriticalLevel').val() == null || $("#ddlCriticalLevel").val() == "" ) {
      ngswal("Warning !", "Please Select Critical Level !", "warning");

    }

    else if ($("#Txt_rootCause").val().trim() == '' && $("#DefectStatus").val() != "Reject") {

      ngswal("Warning !", "Please Enter The RootCause Data !", "warning");

    }
    else
      if (
        $("#DefectStatus").val() != "Reject"

        && $("#Txt_CorrectiveAction").val().trim() == ''
        && $("#Txt_PreventiveAction").val().trim() != '') {
        $('#Txt_PreventiveAction').val("");
        ngswal("Warning !", "Please Enter The Corrective Data  before Preventive Data!", "warning");
      }
      else if ($("#txtDefectResponse").val().trim() != '' && $("#DefectStatus").val() != 'Approve' && $("#DefectStatus").val() != 'Reject') {

        $('#txtDefectResponse').val("");
        ngswal("Warning !", "Please select the defect status before comments!", "warning");
      }
      // separate file upload with same function with the status
      else {
        this.statusRoot = "";
        this.statusCrt = "";

        if (this.file != null) {
          fileName = this.file.name;
          fileSize = this.file.size;
          this.statusRoot = "RootCause";
        } else {
          this.fileBase64 = null;
        }

        if (this.fileCrt != null) {
          fileNameCrt = this.fileCrt.name;
          fileSizeCrt = this.fileCrt.size;
          this.statusCrt = "Corrective";
        } else {

          this.fileBase64Crt = null;
        }


        // for super user if approve or rejected has value then update it check on message also    

        var dataParam = {
          Id: localStorage.aEID,
          RespondedBy: localStorage.roleId,
          RootCasueUser: $("#Txt_RootCauseuser").val(),
          ResponsiblePerson: $("#Txt_ResponsibleUser").val(),
          ComplaintType: $("#ddlComplaintType").val(),
          CriticalLevel: $("#ddlCriticalLevel").val(),
          RootCasue: $("#Txt_rootCause").val(),
          RootCasueBy: 0,
          CorrectiveAction: $("#Txt_CorrectiveAction").val(),
          CorrectiveActionBy: 0,
          PreventiveAction: $("#Txt_PreventiveAction").val(),
          PreventiveActionBy: 0,
          PublisherId: localStorage.aPubID,
          fileName: fileName,
          fileSize: fileSize,
          fileAsBase64: this.fileBase64,
          statusRoot: this.statusRoot,
          fileNameCrt: fileNameCrt,
          fileSizeCrt: fileSizeCrt,
          fileAsBase64Crt: this.fileBase64Crt,
          statusCrt: this.statusCrt,
          UpdatedBy: localStorage.aLoginID,
        };


        if (dataParam.RootCasue.toString() !== '' || dataParam.CorrectiveAction.toString() !== '') {

          if (dataParam.RootCasue.toString() !== '') {
            dataParam.RootCasueBy = localStorage.roleId;
          }
          if (dataParam.CorrectiveAction.toString() !== '') {
            dataParam.CorrectiveActionBy = localStorage.roleId;
          }
        }

        if (dataParam.PreventiveAction.toString() !== '') {
          dataParam.PreventiveActionBy = localStorage.roleId;
        }

        ApiMethod.postMethod('api/UpdateDefectResponse', dataParam).subscribe(
          result => {
            this.recordUpdated.emit();


            if ($("#DefectStatus").val() == 'Approve' || $("#DefectStatus").val() == 'Reject') { //added for super user

              this.UpdateDefectResponse();
            }
            else {
              ngswal({
                position: 'top-end',
                type: "success",
                title: "Updated !",
                text: result._aItem,
                showConfirmButton: true,
              });
              $("#ddlComplaintType").val("").change();
              $("#ddlCriticalLevel").val("").change();
              this.hide();
              $("#LoadingImage").hide();
            }

          }, error => {
            $("#LoadingImage").hide();
            ngswal("Failed !", error.message, "warning");
          });
      }
  }

  //aprove/reject add
  UpdateDefectResponse(): void {
    alert(1);
    alert(2);
    if (($("#ddlComplaintType").val() == null || $("#ddlComplaintType").val() == "")
      && this.chkRootCauseData == "" && $("#DefectStatus").val() != "Reject") {

      ngswal("Warning !", "Please Select Complaint Type !", "warning");

    } else if (($('#ddlCriticalLevel').val() == null || $("#ddlComplaintType").val() == "") && this.chkRootCauseData == ""
      && $("#DefectStatus").val() != "Reject") {

      ngswal("Warning !", "Please Select Critical Level !", "warning");
    }
    else if ($("#Txt_rootCause").val().trim() == '' && !($("#DefectStatus").val() == 'Reject')) {

      ngswal("Warning !", "Please give response for Root Cause !", "warning");
    }
    else if ($("#Txt_rootCause").val().trim() == '' && $("#DefectStatus").val() == 'Approve') {

      ngswal("Warning !", "Please give response for Root Cause before Approval!", "warning");
    } else if ($("#txtDefectResponse").val().trim() != '' && $("#DefectStatus").val() != 'Approve' && $("#DefectStatus").val() != 'Reject') {

      ngswal("Warning !", "Please select the defect status before comments!", "warning");
    }

    else {
      let fileName = null;
      let fileSize = null;
      let fileNameCrt = null;
      let fileSizeCrt = null;

      if (this.file != null) {
        fileName = this.file.name;
        fileSize = this.file.size;
        this.statusCrt = "RootCause";
      } else {
        this.fileBase64 = null;
      }

      if (this.fileCrt != null) {
        fileNameCrt = this.fileCrt.name;
        fileSizeCrt = this.fileCrt.size;
        this.statusCrt = "Corrective";
      } else {
        this.fileBase64Crt = null;
      }
      var dataParam = {
        ID: localStorage.aEID,
        ProductionResponse: $("#txtDefectResponse").val(),
        DefectStatus: $("#DefectStatus").val(),
        UpdatedBy: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        fileName: fileName,
        fileSize: fileSize,
        fileAsBase64: this.fileBase64,
      }
      var message = '';
      if ($("#DefectStatus").val() == 'Approve') {
        var message = 'Defect Approve Successfully';
      }
      if ($("#DefectStatus").val() == 'Reject') {
        var message = 'Defect Rejected Successfully';
      }
    
      ApiMethod.postMethod('api/UpdateDefectRes', dataParam).subscribe(
        result => {
          this.recordUpdated.emit();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: message,
            showConfirmButton: true,
          });
         

          this.hide();
        }, error => {

          ngswal("Failed !", error.message, "warning");

        });
    }
  }

  hide(): void {
    $('#divResponseData').hide();
  }

  DefectDownloadFile() {
    $("#LoadingImage").show();
    var aEid = localStorage.aEID;
    ApiMethod.Downloadfile("api/DownloadDefectFile" + "/" + aEid);
    this.ShowInfoPopUp();
    this.hide();
    $("#LoadingImage").hide();
  }


  hides(): void {
    $('#divResponseData').hide();
  }


  DisablepopupAdd() {
    $("#ddlJournals").attr('disabled', 'disabled');
    $("#ddlIssue").attr('disabled', 'disabled');
    $("#ddlArticle").attr('disabled', 'disabled');
    $("#ddlDefectArea").attr('disabled', 'disabled');
    $("#ddlDefectCategory").attr('disabled', 'disabled');
    $("#ddlDefectInstruction").attr('disabled', 'disabled');
    $("#txtDescription").attr('disabled', 'disabled');
    $("#Txt_DefectDueDate").attr('disabled', 'disabled');
    $("#doc_Defectuploadfile").attr('disabled', 'disabled');
    $("#ddlFeedbackRequest").attr('disabled', 'disabled');

  }


  //  file upload validation and setting the root cause and corrective in response screen .
  //As we are capturing the file name, size and filebase64 for each upload, separate statusvalue passed to differentiate
  onuploadDataSelected(fileInput: any, statusValue: any) {

    if (statusValue == 'RootCause') {
      var ext = $('#doc_DefectCorrectedFile').val().split('.').pop().toLowerCase();
      if ($.inArray(ext, ['doc', 'docx', 'pdf', 'xlsx']) == -1) {

        $('#doc_DefectCorrectedFile').val("");

        ngswal("Failed !", "Invalid File format", "warning");
        return false;
      } else if (fileInput.target.files[0].size > 52428800) {

        $('#doc_DefectCorrectedFile').val("");

        ngswal("Failed !", "Please upload File less than 50MB", "warning");
        return;
      } else if ($("#Txt_rootCause").val().trim() == '' || $("#Txt_rootCause").val().trim() == null) {
        $('#doc_DefectCorrectedFile').val("");
        ngswal("Warning !", "Please update Root cause before uploading", "warning");
      }
      else {
        this.file = fileInput.currentTarget.files[0];

        if (fileInput.currentTarget.files[0]) {
          var fileReader = new FileReader();
          fileReader.onload = (e: any) => {
            this.fileBase64 = null;
            this.fileBase64 = e.currentTarget.result;
          }
          fileReader.readAsDataURL(fileInput.currentTarget.files[0]);

        }

      }

    }

    if (statusValue == 'Corrective') {
      var extcrt = $('#doc_DefectCorrectedFile_crtAct').val().split('.').pop().toLowerCase();

      if ($.inArray(extcrt, ['doc', 'docx', 'pdf', 'xlsx']) == -1) {

        $('#doc_DefectCorrectedFile_crtAct').val("");

        ngswal("Failed !", "Invalid File format", "warning");
        return false;
      } else if (fileInput.target.files[0].size > 52428800) {

        $('#doc_DefectCorrectedFile_crtAct').val("");

        ngswal("Failed !", "Please upload File less than 50MB", "warning");
        return;
      }
      else if ($("#Txt_CorrectiveAction").val().trim() == '' || $("#Txt_CorrectiveAction").val().trim() == null) {
        $('#doc_DefectCorrectedFile_crtAct').val("");
        ngswal("Warning !", "Please update Corrective Action before uploading", "warning");
      } else {
        this.fileCrt = fileInput.currentTarget.files[0];
        if (fileInput.currentTarget.files[0]) {

          var fileReader = new FileReader();
          fileReader.onload = (e: any) => {
            this.fileBase64Crt = null;
            this.fileBase64Crt = e.currentTarget.result;

          }
          fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
        }
      }
    }


  }
  // download the corrective file for root cause
  DefectCorrectedFile(statusCode: any) {
    $("#LoadingImage").show();
    var aEid = localStorage.aEID;
    ApiMethod.Downloadfile('api/DownloadCorrectedFile' + '/' + aEid + '/' + statusCode);
    this.ShowInfoPopUp();
    this.hide();
    $("#LoadingImage").hide();

  }

  ImplementationProcess() {
    $("#LoadingImage").show();
    var paramData = {
      Id: localStorage.aEID,
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID
    };

    ApiMethod.postMethod('api/GetImplementationProcess', paramData).subscribe(
      (Response) => {
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Implemented Successfully !",
          Text: Response.ImplementStage,
          showConfirmButton: true,
        });
        this.hide();
        $("#LoadingImage").hide();
      }, (error) => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      }
    );
  }


  GetClosedDefect() {
    $("#LoadingImage").show();
    var paramData = {
      Id: localStorage.aEID,
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID
    };

    ApiMethod.postMethod('api/GetClosedDefect', paramData).subscribe(
      (Response) => {
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Your Defect Rejected Successfully !",
          Text: Response.ClosedDefect,
          showConfirmButton: true,
        });
        this.hide();
        $("#LoadingImage").hide();
      }, (error) => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      }
    );
  }


}
